export function getPosition(map, def) {
  const str = map?.location_desc || map?.place || def;
  return str;
}

export function tokenizer(text) {
  return text.replace(/\s+/g, '<br/>') || '--';
}
